/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Result of removing a member
 * @export
 * @interface RemoveMemberResponse
 */
export interface RemoveMemberResponse {
    /**
     * 
     * @type {string}
     * @memberof RemoveMemberResponse
     */
    message: string;
}

/**
 * Check if a given object implements the RemoveMemberResponse interface.
 */
export function instanceOfRemoveMemberResponse(value: object): value is RemoveMemberResponse {
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function RemoveMemberResponseFromJSON(json: any): RemoveMemberResponse {
    return RemoveMemberResponseFromJSONTyped(json, false);
}

export function RemoveMemberResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemoveMemberResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'],
    };
}

export function RemoveMemberResponseToJSON(json: any): RemoveMemberResponse {
    return RemoveMemberResponseToJSONTyped(json, false);
}

export function RemoveMemberResponseToJSONTyped(value?: RemoveMemberResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
    };
}

